module.exports = __webpack_public_path__ + "afbc6ff054bc8c7f3548fa2e18c6a0cb.png";